import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lechwerke-storungen',
  templateUrl: './lechwerke-storungen.component.html',
  styleUrls: ['./lechwerke-storungen.component.scss'],
})
export class LechwerkeStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;
  constructor(private _router: Router) {}
  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
